import styled from "styled-components";

export const gradient = "linear-gradient(144.01deg, #ffc951 0%, #c94daa 130%)";

export const Overlay = styled.div`
  position: fixed; inset: 0; z-index: 1000;
  background: rgba(0,0,0,0.45);
  display: flex; align-items: center; justify-content: center;
  padding: 20px;
`;

export const ModalCard = styled.div`
  width: 100%; max-width: 680px;
  background: #fff;
  border-radius: 20px;
  overflow: hidden;
  box-shadow: 0 24px 60px rgba(0,0,0,0.18);
`;

export const ModalHeader = styled.div`
  display: flex; align-items: center; justify-content: space-between;
  padding: 20px 24px 16px;
`;

export const ModalTitle = styled.h2`
  margin: 0;
  font-size: 22px; font-weight: 800; color: #171717;
`;

export const CloseBtn = styled.button`
  background: none; border: none;
  font-size: 26px; line-height: 1; color: rgba(23,23,23,0.5);
  cursor: pointer; padding: 0 4px;
  &:hover { color: #171717; }
`;

export const ModalDivider = styled.div`height: 1px; background: rgba(23,23,23,0.08);`;

export const ModalBody = styled.div`
  padding: 20px 24px;
  max-height: 60vh;
  overflow-y: auto;
`;

export const CancelBtn = styled.button`
  height: 40px; padding: 0 18px;
  border: 1px solid rgba(23,23,23,0.15); border-radius: 8px;
  font-family: Montserrat, sans-serif; font-size: 13px; font-weight: 700;
  color: rgba(23,23,23,0.7); background: #fff; cursor: pointer;
  &:hover { background: #f8f9fa; color: #171717; }
`;

export const SaveBtn = styled.button`
  height: 40px; padding: 0 20px;
  border: none; border-radius: 8px;
  background: ${gradient}; color: #fff;
  font-family: Montserrat, sans-serif; font-size: 13px; font-weight: 700;
  cursor: pointer; box-shadow: 0 8px 18px rgba(201,77,170,0.22);
  &:hover { transform: translateY(-1px); }
`;

export const ModalFooter = styled.div`
  display: flex; align-items: center; justify-content: flex-end;
  gap: 12px; padding: 16px 24px 20px;
  background: #fdfdfd;
`;
